<template>
  <div class="envelope-front" style="width: 305px;">
    <!-- eslint-disable vue/max-len -->
    <svg viewBox="0 0 278 205" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.554688 0.260742H20.7459C21.8948 0.260742 23.0133 0.629893 23.9365 1.31377L276.802 188.626C277.484 189.132 277.887 189.931 277.887 190.78V193.459C277.887 199.757 272.782 204.862 266.485 204.862H11.9569C5.65965 204.862 0.554688 199.757 0.554688 193.459V0.260742Z"
        fill="#E4EAF1"
      />
      <path
        d="M277.889 0.260742H257.697C256.549 0.260742 255.43 0.629893 254.507 1.31377L1.64127 188.626C0.958893 189.132 0.556458 189.931 0.556458 190.78V193.459C0.556458 199.757 5.66141 204.862 11.9586 204.862H266.486C272.784 204.862 277.889 199.757 277.889 193.459V0.260742Z"
        fill="#E4EAF1"
      />
      <path
        d="M277.889 184.16C277.889 183.309 277.484 182.508 276.799 182.003L151.148 89.4028C144.057 84.1767 134.389 84.1767 127.298 89.4028L1.64728 182.003C0.961823 182.508 0.55719 183.309 0.55719 184.16V193.461C0.55719 199.759 5.66214 204.864 11.9594 204.864H266.486C272.784 204.864 277.889 199.759 277.889 193.461L277.889 184.16Z"
        fill="#F3F8FE"
      />
    </svg>
  </div>
</template>
